import React from 'react'

function WholesaleProduct() {
    return (
        <div>WholesaleProduct</div>
    )
}

export default WholesaleProduct